import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ScreenClassProvider, setConfiguration } from 'react-grid-system';
import { logger } from '@sendpayments/js-utils';
import { useBreakpoint } from '../../components/MediaBreakpoint';

// for react-grid-system the first point is cm, but we use it as sm
const mapBreakpoints = ({ xs, sm, md, lg, xl }) => [xs, sm, md, lg, xl];

// matching adobe design system responsive design
const getGutterWidth = ({ isXs, isSm, isMd, isLg, isXl }) => {
  if (isXs) {
    return 16;
  }

  if (isSm) {
    return 24;
  }

  if (isMd) {
    return 32;
  }

  if (isLg) {
    return 40;
  }

  if (isXl) {
    return 48;
  }

  return 16;
};

const GridProvider = ({ children, breakpoints }) => {
  const { isMedia } = useBreakpoint(breakpoints);

  const isXs = isMedia({ to: breakpoints.xs });
  const isSm = isMedia({ from: breakpoints.xs, to: breakpoints.sm });
  const isMd = isMedia({ from: breakpoints.sm, to: breakpoints.md });
  const isLg = isMedia({ from: breakpoints.md, to: breakpoints.lg });
  const isXl = isMedia({ from: breakpoints.lg, to: breakpoints.xl });

  useEffect(() => {
    const breakpointsMapped = mapBreakpoints(breakpoints);
    setConfiguration({ breakpoints: breakpointsMapped });
    logger.log('GridProvider', 'setting grid system breakpoint', breakpointsMapped);
  }, []);

  useEffect(() => {
    const gutterWidth = getGutterWidth({ isXs, isSm, isMd, isLg, isXl });
    setConfiguration({ gutterWidth });
    logger.log('GridProvider', 'updating grid system configuration', { isXs, isSm, isMd, isLg, isXl, gutterWidth });
  }, [isXs, isSm, isMd, isLg, isXl]);

  return <ScreenClassProvider>{children}</ScreenClassProvider>;
};

GridProvider.propTypes = {
  children: PropTypes.any.isRequired,
  breakpoints: PropTypes.object.isRequired,
};

export default GridProvider;
